module.exports = __webpack_public_path__ + "static/img/code.daa0e90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.jpg
// module id = GwFP
// module chunks = 1